import { CHANNEL_NAME, DISCOUNT_CODE_ERRORS } from '../../constants';
import apiUtils from '../../utils/apiUtils';

const DRC_DISCOUNT_MAX_LENGTH = 20;

const discountService = {
  applyDiscount: async function ({ config, discountCode }) {
    const { apiAccessToken, baseURL, brand, environment } = config;

    const discountCodeClean = discountCode.trim().substring(0, DRC_DISCOUNT_MAX_LENGTH);

    const isProd = environment === 'prod';

    const path = `/digital-railcards/discount/${discountCodeClean}/channel/${CHANNEL_NAME}`;
    const url = isProd ? `https://api.${baseURL}${path}` : `https://api-${brand}.${baseURL}${path}`;

    const response = await apiUtils.get({ apiAccessToken, url });

    const discountedRailcards = {};
    const result = {};

    response?.map?.((discount) => {
      if (discount?.discountId !== null) {
        const currentRailcard = discount?.railcardOption;

        discountedRailcards[currentRailcard?.railcardCode] = {
          oneYearPrice: currentRailcard?.oneYearPrice,
          threeYearPrice: currentRailcard?.threeYearPrice,
        };

        result.discountId = discount?.discountId;
      }
    });

    if (!result.discountId) {
      throw new Error(DISCOUNT_CODE_ERRORS.INVALID);
    }

    result.railcards = discountedRailcards;

    return {
      discounts: result,
      success: true,
    };
  },
};

export default discountService;
